import * as httpHolder from './httpHolder';

/**
 *
 * @param {url diretto per il get dell'entità} href
 */
export function getByHref(href){

    return httpHolder.getInstance().get({url: href}, {withCredentials: true});
}


/**
 * restituisce i subaccount
 * @param {account id} parentId
 */
export function fetchSubAccounts(parentId){
    return httpHolder.getInstance().get('connect/services/accounts/' + parentId, {withCredentials: true});
}

/**
 * get device by id
 * @param {device id} id
 */
export function getDeviceById(id){
    return httpHolder.getInstance().get('connect/services/devices/' + id, {withCredentials: true});
}

/**
 * get system of units by name
 * @param {nome} name
 */
export function getSystemUnits(name){
    return httpHolder.getInstance().get('connect/services/systemofunits/name/' + name, {withCredentials: true});
}

/**
 * Cerca device per IMEI, ESN o id
 * @param {device id} id
 * @param {"ESN", "IMEI", "Id"} idType
 */
export function getDeviceByType(id, idType) {
    if (!idType) {
        idType = "ESN";
    }

    if (idType === "ESN") {
        return httpHolder.getInstance().get('connect/services/devices/esn/' + id, {withCredentials: true});
    }

    if (idType === "IMEI") {
        var request =
        {
            search: {
                searchTerms: {
                    imei: id
                }
            }
        };

        return httpHolder.getInstance().post('connect/services/devices/search', request);
    }

    //Invoke api service
    return httpHolder.getInstance().get('connect/services/devices/' + id, {withCredentials: true});
}

/**
 * get account by id
 * @param {account id} id
 */
export function getAccountById(id){
    return httpHolder.getInstance().get('connect/services/accounts/' + id, {withCredentials: true});
}




// WEBPACK FOOTER //
// ./src/services/apis/calAmp/entityServices.js